import React from "react";

import SwitchVerticalIcon from "@uui/SwitchVertical01";
import { toLower } from "lodash/fp";

import styled from "@mui/material/styles/styled";

import type { SearchResult } from "@app/analytics/types";
import type { SortOption } from "@app/common/hooks/useSortData";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import Button from "@rui/Button";
import DropdownMenuItem from "@rui/Dropdown/DropdownMenuItem";
import Menu from "@rui/Menu";

type SearchSortOption = SortOption<SearchResult>;

export const SORT_OPTIONS: SearchSortOption[] = [
  {
    id: "relevance",
    label: "Relevance",
    sortFn: (data) => -data.relevance,
  },
  {
    id: "date_desc",
    label: "Date (newest first)",
    sortFn: (data) => -data.startDate.toMillis(),
  },
  {
    id: "date_asc",
    label: "Date (oldest first)",
    sortFn: (data) => data.startDate.toMillis(),
  },
];

const StyledMenu = styled(Menu)({
  "& .MuiList-root": {
    padding: "8px 0",
  },
  "& .MuiMenuItem-root": {
    padding: "4px 8px",
  },
});

const SearchResultSortMenu = ({
  selected,
  onSortChange,
}: {
  selected: SearchSortOption;
  onSortChange: (sort: SearchSortOption) => void;
}) => {
  const { open, onClose, onClick, anchorElement } = useAnchorElement();

  const handleSelectOption = (newSort: SearchSortOption) => () => {
    onSortChange(newSort);
    onClose();
  };

  return (
    <>
      <Button
        variant="text"
        startIcon={<SwitchVerticalIcon />}
        sx={{ height: "fit-content" }}
        onClick={onClick}
      >
        Sorted by {toLower(selected.label)}
      </Button>
      <StyledMenu open={open} onClose={onClose} anchorEl={anchorElement}>
        {SORT_OPTIONS.map((opt) => (
          <DropdownMenuItem
            key={opt.label}
            label={opt.label}
            selected={selected.label === opt.label}
            onClick={handleSelectOption(opt)}
          />
        ))}
      </StyledMenu>
    </>
  );
};

export default SearchResultSortMenu;
